module.exports = __webpack_public_path__ + "static/keyboard-14f5fd3a8e14d3de49f67e89f15dd7c6.svg";